<template>
  <div id="notification-settings">
    <div class="row">
      <div class="col">
        <h3>Notification Settings</h3>
      </div>
    </div>
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else>
      <div class="row">
        <p class="col-sm-12 col-lg-12">How do you want to get notifications?</p>
        <div class="col-sm-6 col-lg-2">
          <label for="dashboard">via E-Mail</label>
          <fg-input
            id="mail"
            type="radio"
            @checked="form.notification_channels.mail = $event"
            :selected="form.notification_channels.mail"
          >
          </fg-input>
        </div>
        <div class="col-sm-6 col-lg-2">
          <label for="dashboard">on Dashboard</label>
          <fg-input
            id="dashboard"
            type="radio"
            @checked="form.notification_channels.database = $event"
            :selected="form.notification_channels.database"
          >
          </fg-input>
        </div>
      </div>
      <div class="row"></div>
      <div class="row">
        <p class="col-sm-12 col-lg-12">Which notifications do you want to receive?</p>
        <div class="col-sm-2 col-lg-2">
          <label for="new_suggestion">New Suggestions</label>
          <fg-input
            id="new_suggestion"
            type="radio"
            @checked="form.notifications_types.new_suggestions = $event"
            :selected="form.notifications_types.new_suggestions"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-2">
          <label for="suggestion_approved">Suggestion approved</label>
          <fg-input
            id="suggestion_approved"
            type="radio"
            @checked="form.notifications_types.suggestion_approved = $event"
            :selected="form.notifications_types.suggestion_approved"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-3">
          <label for="high_fluctuation">Outliers, peaks or high fluctuation</label>
          <fg-input
            id="high_fluctuation"
            type="radio"
            @checked="form.notifications_types.high_fluctuation = $event"
            :selected="form.notifications_types.high_fluctuation"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-3">
          <label for="higher_average_consumption">Higher average consumption</label>
          <fg-input
            id="higher_average_consumption"
            type="radio"
            @checked="form.notifications_types.higher_average_consumption = $event"
            :selected="form.notifications_types.higher_average_consumption"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-2">
          <label for="continuously_rising_consumption">Continuously rising consumption</label>
          <fg-input
            id="continuously_rising_consumption"
            type="radio"
            @checked="form.notifications_types.continuously_rising_consumption = $event"
            :selected="form.notifications_types.continuously_rising_consumption"
          >
          </fg-input>
        </div>
      </div>
      <div class="row"></div>
      <div class="row">
        <p class="col-sm-12 col-lg-12">How often do you want to receive?</p>
        <div class="col-sm-2 col-lg-2">
          <label for="immediately">Immediately</label>
          <fg-input
            id="immediately"
            type="radio"
            @checked="form.regularity_of_receipt.immediately = $event"
            :selected="form.regularity_of_receipt.immediately"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-2">
          <label for="daily">Daily</label>
          <fg-input
            id="daily"
            type="radio"
            @checked="form.regularity_of_receipt.daily = $event"
            :selected="form.regularity_of_receipt.daily"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-2">
          <label for="weekly">Weekly</label>
          <fg-input
            id="weekly"
            type="radio"
            @checked="form.regularity_of_receipt.weekly = $event"
            :selected="form.regularity_of_receipt.weekly"
          >
          </fg-input>
        </div>
        <div class="col-sm-2 col-lg-2">
          <label for="monthly">Monthly</label>
          <fg-input
            id="monthly"
            type="radio"
            @checked="form.regularity_of_receipt.monthly = $event"
            :selected="form.regularity_of_receipt.monthly"
          >
          </fg-input>
        </div>
      </div>
      <div class="row pt-6">
        <p class="col-sm-12 col-lg-12">
          How soon do you want to be notified about irregularities in your consumption data?
        </p>
        <div class="col-sm-2 col-lg-2 ml-6">
          <vue-slider height="24px" v-model="value1" :adsorb="true" :data="data1" :marks="true"></vue-slider>
        </div>
      </div>
      <div class="row pt-10">
        <p class="col-sm-12 col-lg-12">
          How high should the threshold for detecting an irregularity in your consumption data be?
        </p>
        <div class="col-sm-2 col-lg-2 ml-6">
          <vue-slider height="24px" v-model="value2" :adsorb="true" :data="data2" :marks="true"></vue-slider>
        </div>
      </div>
      <div class="row"></div>
      <div class="row">
        <div class="col text-left">
          <p-button type="success" :loading="loadingSave" round @click.native.prevent="save()">
            {{ $t('save') }}
          </p-button>
        </div>
      </div>
    </div>

    <!--    <h3>Notification Types</h3>-->
    <!--    <div class="row">-->

    <!--    </div>-->
  </div>
</template>

<script>
import UserNotificationChannelsController from '@/controllers/Notification/UserNotificationChannelsController';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import NotificationSettingController from '@/controllers/Notification/NotificationSettingController';
import 'vue-slider-component/theme/antd.css';

export default {
  name: 'NotificationSettings',
  components: { MoonLoader },
  data() {
    return {
      form: {
        notifications_types: {},
        regularity_of_receipt: {},
        notification_channels: {},
      },
      loadingSave: false,
      loading: false,
      value1: 'very early',
      data1: ['very early', 'very late'],
      value2: 'very late',
      data2: ['very early', 'very late'],
    };
  },
  async mounted() {
    this.loading = true;
    await this.setForm();
    this.loading = false;
  },
  methods: {
    async save() {
      try {
        let user = await UserNotificationChannelsController.store(this.form);
        await NotificationSettingController.update(this.form, this.$store.getters.user.user_id);
        this.$gtag.event('Notification Channel Updated', {
          method: 'Google',
          value: this.form,
        });
        this.$store.commit('storeUser', user);
        this.$notify({
          type: 'success',
          title: 'Successfully saved!',
        });
      } catch (e) {
        this.$gtag.exception({
          description: 'Error By Updating Notification Channel',
          fatal: false,
        });
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
    async setForm() {
      if (this.$store.getters.user.notification_channels) {
        let notification_setting = await NotificationSettingController.index(this.$store.getters.user.user_id);
        if (Object.keys(notification_setting).length !== 0) {
          this.form.notifications_types = notification_setting.notification_types;
          this.form.regularity_of_receipt = notification_setting.regularity_of_receipt;
        }
        this.form.notification_channels = this.$store.getters.user.notification_channels;
      }
    },
  },
};
</script>

<style>
#notification-settings .vue-slider-rail {
  background-color: #fff;
  /* height: 6px; */
  border-radius: 2px;
}

#notification-settings .vue-slider-dot-tooltip-inner {
  background-color: #fff;
  color: #000;
}

#notification-settings .vue-slider-mark-active {
  /* background-color: #4caf50; */
  border-color: #4caf50;
}

#notification-settings .vue-slider-mark-step-active {
  box-shadow: 0 0 0 2px #4caf50;
}

#notification-settings .vue-slider-dot-handle {
  border-color: #4caf50;
}

#notification-settings .vue-slider-process {
  background-color: rgba(76, 175, 80, 0.5);
}

#notification-settings .vue-slider-ltr .vue-slider-mark-label {
  left: 100%;
}
</style>
